/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free number to words converter. Type a number and get it written out in English words — handy for cheques, invoices and contracts. Works in your browser.`)
};

const es_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito de números a palabras. Escribe un número y obtenlo escrito en palabras inglesas — útil para cheques, facturas y contratos. Funciona en tu navegador.`)
};

const de_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zahlen-in-Worte-Konverter. Geben Sie eine Zahl ein und erhalten Sie sie in englischen Worten ausgeschrieben — praktisch für Schecks, Rechnungen und Verträge. Funktioniert direkt in Ihrem Browser.`)
};

const nl_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis getal naar woorden omzetter. Typ een getal en zet het om in Engelse woorden — handig voor cheques, facturen en contracten. Werkt in uw browser.`)
};

const fr_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de nombres en lettres. Tapez un nombre et obtenez son écriture en toutes lettres — pratique pour les chèques, factures et contrats. Fonctionne dans votre navigateur.`)
};

const it_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore gratuito da numeri a parole. Digita un numero e ottenilo scritto in parole inglesi — utile per assegni, fatture e contratti. Funziona nel tuo browser.`)
};

const pt_br2_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de números em palavras. Digite um número e obtenha-o escrito em palavras em português — útil para cheques, notas fiscais e contratos. Funciona no seu navegador.`)
};

const pt_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de números para palavras. Digite um número e obtenha-o escrito em palavras inglesas — útil para cheques, faturas e contratos. Funciona no seu navegador.`)
};

const ja_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の数字を単語に変換するツール。数字を入力して、英語の単語で書き出されたテキストを取得してください。小切手、請求書、契約書に便利です。ブラウザで動作します。`)
};

const zh_nw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的数字转文字转换器。输入数字，即可获得英文单词拼写形式——适用于支票、发票和合同。可在浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_meta_description", locale)
	if (locale === "en") return en_nw_meta_description(inputs)
	if (locale === "es") return es_nw_meta_description(inputs)
	if (locale === "de") return de_nw_meta_description(inputs)
	if (locale === "nl") return nl_nw_meta_description(inputs)
	if (locale === "fr") return fr_nw_meta_description(inputs)
	if (locale === "it") return it_nw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_nw_meta_description(inputs)
	if (locale === "pt") return pt_nw_meta_description(inputs)
	if (locale === "ja") return ja_nw_meta_description(inputs)
	return zh_nw_meta_description(inputs)
};